/**
 * This sets the negative margin on the video box contents so they can be any height
 */
 
import $ from 'jquery';

// Cached elements
const $el = {
	videoBox: $('.c-video-item')
};

// Module events
export default function init() {
	positionContent();
}

export function positionContent() {
	$el.videoBox.each(function() {
		const $this = $(this);
		const subContentHeight = $this.find('.c-video-item__subcontent').outerHeight() + 10;
		const $content = $this.find('.c-video-item__content');
		
		$content.css('transform', `translateY(${subContentHeight}px)`);
		
		// Show the content once we've set the negative margin
		$content.css('opacity', '1');
	});
}